var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "codigo",
                  name: "codigo",
                  placeholder: "Escriba un código..."
                },
                model: {
                  value: _vm.form.codigo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "codigo", $$v)
                  },
                  expression: "form.codigo"
                }
              },
              [
                _vm._v("\n          Código\n          "),
                _vm.errores.codigo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.codigo[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "descripcion",
                  name: "descripcion",
                  placeholder: "Escriba un nombre o descripción..."
                },
                model: {
                  value: _vm.form.descripcion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "descripcion", $$v)
                  },
                  expression: "form.descripcion"
                }
              },
              [
                _vm._v("\n          Nombre/Descripción\n          "),
                _vm.errores.descripcion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.descripcion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "numero_identificacion",
                  name: "numero_identificacion",
                  placeholder: "Escriba una identificación...",
                  readonly: _vm.form.id != ""
                },
                model: {
                  value: _vm.form.numero_identificacion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "numero_identificacion", $$v)
                  },
                  expression: "form.numero_identificacion"
                }
              },
              [
                _vm._v("\n          Número de identificación\n          "),
                _vm.errores.numero_identificacion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.numero_identificacion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  placeholder: "Escriba una dirección...",
                  id: "direccion",
                  name: "direccion"
                },
                model: {
                  value: _vm.form.direccion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "direccion", $$v)
                  },
                  expression: "form.direccion"
                }
              },
              [
                _vm._v("\n          Dirección\n          "),
                _vm.errores.direccion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.direccion[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  placeholder: "Escriba uno o varios teléfonos...",
                  id: "telefonos",
                  name: "telefonos"
                },
                model: {
                  value: _vm.form.telefonos,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "telefonos", $$v)
                  },
                  expression: "form.telefonos"
                }
              },
              [
                _vm._v("\n          Teléfono(s)\n          "),
                _vm.errores.telefonos
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.telefonos[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-6" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  placeholder: "Escriba uno o varios correos...",
                  id: "correos",
                  name: "correos"
                },
                model: {
                  value: _vm.form.correos,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "correos", $$v)
                  },
                  expression: "form.correos"
                }
              },
              [
                _vm._v("\n          Correo(s)\n          "),
                _vm.errores.correos
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.correos[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-info btn--text",
          attrs: { "v-show": _vm.form.id != "" },
          on: { click: _vm.clonar }
        },
        [
          _c("i", { staticClass: "fa fa-clone" }),
          _c("span", [_vm._v("Crear como verificador")])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-primary btn--text",
          attrs: { "v-show": _vm.form.id != "" },
          on: { click: _vm.crearComoUsuario }
        },
        [
          _c("i", { staticClass: "fa fa-users" }),
          _c("span", [_vm._v("Crear como usuario")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h5", [_vm._v("Vendedor")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-02473a4c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02473a4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/vendedores/Vendedor.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-02473a4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/vendedores/Vendedor.vue
// module chunks = 0